import { Component, OnInit } from '@angular/core';
import { ProductoAlpha, } from 'src/app/models/productoAlpha';
import { environment } from 'src/environments/environment';
import { CarritoService } from '../../servicios/carrito.service';
import { CarritoAlphaService } from '../../servicios/carrito-alpha.service';
import { Subscription } from 'rxjs';
import { ClienteService } from 'src/app/servicios/cliente.service';
import { AlertController, ToastController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { timer } from 'rxjs';
import { Cliente } from 'src/app/models/cliente';

@Component({
    selector: 'app-carrito',
    templateUrl: './carrito.page.html',
    styleUrls: ['./carrito.page.scss'],
    standalone: false
})
export class CarritoPage implements OnInit {
  static idOdoo: number;
  static club: string;
  static terminos: boolean;
  cliente: Cliente;
  filtroActivo: 'servicios' | 'estacionamiento' = 'servicios';
  todosLosProductos: Array<ProductoAlpha> = [];
  productosEstacionamiento: Array<ProductoAlpha> = [];
  productos: ProductoAlpha[] = [];
  query = '';
  isLoading = true;
  isLoadingServicios = true;
  isLoadingEstacionamiento = true;
  productsInCart = 0;
  cartSubscribe!: Subscription;
  tipoCliente: string;

  constructor(private carritoAlphaService: CarritoAlphaService, private carritoService: CarritoService,
    private toastController: ToastController, private clienteService: ClienteService, private activatedRoute: ActivatedRoute,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    if (environment.terminos === true) {
      console.log('has aceoptado los terminos');
    }
    else {
      this.aceptarTerminos();
    }

    this.cliente = JSON.parse(sessionStorage.getItem('datos') || '{}');
    CarritoPage.idOdoo = this.cliente.idOdoo;
    CarritoPage.club = this.cliente?.club?.nombre;
    this.tipoCliente = this.cliente?.tipoCliente?.nombre;

    this.cartSubscribe = this.carritoService.cart.subscribe({
      next: (cart) => {
        this.productsInCart = cart ? cart?.itemsInCart : 0;
      },
      error: (e) => {
        console.log(e);
      }
    });

    this.getProductos();
    this.getPasesEstacionamiento();
  }

  // ----------Obtención de productos del club----------
  async getProductos() {
    this.isLoadingServicios = true;
    this.actualizarLoading();

    this.carritoAlphaService.getProductos(CarritoPage.idOdoo).subscribe({
      next: (data) => {
        this.todosLosProductos = data || [];
        this.isLoadingServicios = false;
        this.actualizarLoading();
        if (this.filtroActivo === 'servicios') {
          this.querySearch();
        }
      },
      error: (error) => {
        console.error('Error al obtener los productos del club:', error);
        this.presentToast('Error al obtener los productos.');
        this.isLoadingServicios = false;
        this.actualizarLoading();
      }
    });
  }

  // ----------Obtención de pases de estacionamiento----------
  async getPasesEstacionamiento() {
    this.isLoadingEstacionamiento = true;
    this.actualizarLoading();

    this.carritoAlphaService.getCatalogoPasesEstacionamiento().subscribe({
      next: (data) => {
        if (data && data.clubes) {
          // Filtrar clubes en estado ERROR o que no tengan opciones disponibles
          const clubesDisponibles = data.clubes.filter(
            (c) => c.estado === 'DISPONIBLE' && c.opciones && c.opciones.length > 0
          );

          this.productosEstacionamiento = clubesDisponibles.map((club) => {
            const infoClub = this.obtenerInfoClub(club.displayName);
            const preciosOrdenados = [...club.opciones].sort((a, b) => b.minQuantity - a.minQuantity);

            const productoEst: ProductoAlpha = {
              product_id: club.productId,
              id_product_tmpl: data.productTmplId,
              name_product_tmpl: club.name,
              display_name_product_tmpl: club.displayName,
              description_producto: infoClub.descripcion,
              image_1920_product_tmpl: infoClub.logo,
              precio_default: preciosOrdenados[preciosOrdenados.length - 1]?.fixedPrice || 0,
              catalogo_precios: preciosOrdenados.map((op, idx) => ({
                id: idx + 1,
                min_quantity: op.minQuantity,
                minQuantity: op.minQuantity,
                fixed_price: op.fixedPrice,
                fixedPrice: op.fixedPrice,
              })),
              colorClub: infoClub.color,
              esEstacionamiento: true,
            };
            return productoEst;
          });
        }
        this.isLoadingEstacionamiento = false;
        this.actualizarLoading();
        if (this.filtroActivo === 'estacionamiento') {
          this.querySearch();
        }
      },
      error: (error) => {
        console.error('Error al obtener catálogo de pases de estacionamiento:', error);
        this.isLoadingEstacionamiento = false;
        this.actualizarLoading();
      }
    });
  }

  // ----------Identificación de Logo, Color y Descripción según Club----------
  obtenerInfoClub(displayName: string) {
    const d = (displayName || '').toLowerCase();
    if (d.includes('cimera')) {
      return {
        logo: 'assets/images/logo-cimera-pases.png',
        color: '#9c8311',
        descripcion: 'Pases de estacionamiento para acceso vehicular en Cimera Gym Club.'
      };
    } else if (d.includes('sports')) {
      return {
        logo: 'assets/images/logo-sports-pases.png',
        color: '#4f2683',
        descripcion: 'Pases de estacionamiento para acceso vehicular en Sports Plaza.'
      };
    } else if (d.includes('cenit')) {
      return {
        logo: 'assets/images/logo_credencial/cenit-logo.png',
        color: '#A71930',
        descripcion: 'Pases de estacionamiento para acceso vehicular en Cenit Gym.'
      };
    } else {
      return {
        logo: 'assets/images/logo-alphan.png',
        color: '#0075C9',
        descripcion: 'Pases de estacionamiento para acceso vehicular en Club Alpha.'
      };
    }
  }

  // ----------Cambio de Filtro de Categoría----------
  cambiarFiltro(filtro: 'servicios' | 'estacionamiento') {
    if (this.filtroActivo === filtro) {
      return;
    }
    this.filtroActivo = filtro;
    this.actualizarLoading();
    this.querySearch();
  }

  actualizarLoading() {
    this.isLoading = this.filtroActivo === 'servicios' ? this.isLoadingServicios : this.isLoadingEstacionamiento;
  }

  // ----------Manejo de búsqueda de productos----------
  onSearchChange(event: any) {
    this.query = (event?.target?.value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    this.querySearch();
  }

  querySearch() {
    this.actualizarLoading();
    const listaOrigen = this.filtroActivo === 'servicios'
      ? (this.todosLosProductos || [])
      : (this.productosEstacionamiento || []);

    if (this.query && this.query.trim().length > 0) {
      this.productos = listaOrigen.filter((product) => {
        const nombre = (product.display_name_product_tmpl || product.name_product_tmpl || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        return nombre.includes(this.query);
      });
    } else {
      this.productos = [...listaOrigen];
    }
  }

  // --------------------Carga según club-------------------------

  cargaralpha(): boolean {
    if (environment.club === 'alpha') {
      return true;
    }
  }

  cargarcimera(): boolean {
    if (environment.club === 'cimera') {
      return true;
    }
  }

  cargarsports(): boolean {
    if (environment.club === 'sports') {
      return true;
    }
  }

  cargarcenit(): boolean {
    if (environment.club === 'cenit') {
      return true;
    }
  }

  async presentToast(msj: string) {
    const toast = await this.toastController.create({
      message: msj,
      duration: 1000,
      position: 'bottom'
    });
    toast.present();
  }

  alertTerminos(): Promise<boolean> {
    return new Promise((resolve) => {
      this.alertCtrl
        .create({
          header: 'PROGRAMA ALPHA PLUS',
          subHeader: 'SERVICIO: ACCEDE A NUESTROS 4 CLUBES DEPORTIVOS COMO MIEMBROS BENEFICIARIOS ACTIVOS DE LOS CLUBES ALPHA Y CIMERA.',
          message: 'Términos y condiciones: <br>'
            + '1.Programa ofrecido por FUNDACIÓN CLUB ALPHA DE PUEBLA, (en adelante CLUB ALPHA).<br>'
            + '2.El programa ALPHA PLUS consiste en dar acceso a los Miembros Beneficiarios activos de CLUB ALPHA a los Clubes Deportivos que integran a la FUNDACIÓN CLUB ALPHA DE PUEBLA. Mediante la compra de “visitas” que pueden adquirir a través de las aplicaciones móviles” CIMERA APP” y “CLUB ALPHA” descargables en IOS y “o ANDROID. Los usuarios visitantes podrán reservar clases e instalaciones mediante la app. <br>'
            + '3.Los accesos de visita son personales y serán utilizados por cualquier integrante de la membresía.<br>'
            + '4.La vigencia de la visita para cualquier ingreso a un Club Deportivo será de 30 días naturales.<br>'
            + '5.Los Miembros Beneficiarios activos, deberán estar al corriente de sus pagos de las membresías adquiridas, así como los servicios adicionales que contraten para aplicar el programa de Alpha Plus.<br>'
            + '6.Programa válido para todos los clubes deportivos de Fundación Club Alpha de Puebla, Club Alpha 2, Club Alpha 3, Sports Plaza y Cimera Gym Club.<br>'
            + '7.Programa válido para todos los Miembros Beneficiarios Activos y Dependientes que cuenten con una membresía activa individual, dual, Familiar, Grupal, Platinum, en cualquiera de sus modalidades, Biclub o Multiclub. Los accesos de visita son personales y utilizados por cualquier integrante de las membresías.<br>'
            + '8.Programa no válido para Usuarios Activos de Sports Plaza, ni usuarios con Horario Especial dentro de ellos clubes deportivos.  Usuarios externos o público en general.   No incluye los servicios de: Alphacuatic, Aquacimera, Health Studio Fisioterapia, Talleres Deportivos. Servicios que tienen costos adicionales en caso de adquirir dentro del club que se esté visitando.<br>'
            + '9.El programa no será aplicable para usuarios Wellhub y todos aquellos usuarios que no tengan una membresía activa de los clubs mencionados<br>'
            + '10.Para que el Miembro Beneficiario Activo o Dependiente pueda obtener su pase de visita, forzosamente, al ingresar al club solicitado, deberá ingresar por los torniquetes de entrada utilizando su registro facial; si por algún motivo imputable al Miembro Beneficiario Activo o Dependiente, el personal de Staff brinda el acceso sin dicho registro, la visita no será contabilizada para los efectos de la presente; sin embargo, si por fallas en el sistema de acceso al club, no se puede registrar la asistencia, personal de Staff intentará resolver en ese momento el inconveniente, de no ser posible esto, brindarán el acceso sin el registro en el sistema y reportan al área correspondiente su asistencia.<br>'
            + '11.Para efectos del presente programa, si el Miembro Beneficiario Activo o Dependiente asiste más de 2 (dos) veces en un día ya sea al mismo club o a otro distinto, se le contará como 1 (una) visita por acceso a cada club; asimismo no se acumularán visitas entre integrantes de una misma membresía, es decir que las visitas serán contabilizadas de manera individual por cada compra mediante “el carrito” de la app CIMERA APP” y “CLUB ALPHA”.<br>'
            + '12.En caso de que el Miembro Beneficiario Activo o Dependiente cancele su membresía durante la vigencia de la presente compra de “visita” o solicite el “permiso de Ausencia” de su membresía, previo al uso de su pase de “visita” se perderá, y no podrá ser utilizado por el dependiente y no podrá ser recuperado, reclamado ni reembolsado en efectivo ni en especie o cualquier otra modalidad de redención.<br>'
            + '13.En caso de que al Usuario Titular o Dependiente, le sea rescindido el contrato o suspendida la membresía temporalmente por faltas al mismo o al reglamento o que la membresía sea declarada inactiva por falta de pago, el pase de visita se perderá y no podrán ser recuperados, reclamados ni reembolsados en efectivo ni en especie.<br>'
            + '14.La promoción es intransferible e improrrogable y no podrá ser cambiada, canjeable o reembolsable por dinero en efectivo, ni por alguna otra modalidad de redención, ni en especie, ni por algún otro servicio ofrecido por Fundación Club Alpha de Puebla, asimismo no serán acumulable con otras promociones, ni descuentos.<br>'
            + '15.Si por causas de fuerza mayor no imputables a Fundación Club Alpha de Puebla, las autoridades ordenan el cierre de sus instalaciones durante la redención del pase de “visita”, éste se perderá y no serán objeto de reclamación ni recuperación alguna ni podrán ser prorrogable, canjeable ni reembolsable por dinero en efectivo, ni en especie o cualquier otra modalidad.<br>',
          buttons: [
            {
              text: 'Aceptar',
              role: 'confirm',
              handler: () => resolve(true),
            },
          ],
        })
        .then(alert => {
          // Now we just need to present the alert
          alert.present();
        });
    });
  }
  aceptarTerminos() {
    this.alertTerminos().then(ok => {
      if (ok) {
        console.log('Haz aceptado los terminos y Condiciones');
        environment.terminos = true;

        // Mostrar alerta de disponibilidad
        if (!localStorage.getItem('aceptaVerDisponiilidad')) {
          //Mostrar alerta de disponibilidad
          this.alertCtrl.create({
            header: 'Disponibilidad en Mis Citas',
            message: 'Recuerda revisar en "Mis citas" las clases que puedes reservar, por favor verifica antes de realizar tu compra.',
            buttons: ['Aceptar']
          }).then(alert => alert.present());
          // Bandera para comprobar que ya se mostro solo una vez la alerta.
          localStorage.setItem('aceptaVerDisponiilidad', 'true');
        }
      }
    });
  }
}
